import { configureStore } from '@reduxjs/toolkit';
import contactReducer from './slices/contactSlice';
import insightReducer from './slices/insightSlice';

export const store = configureStore({
  reducer: {
    contacts: contactReducer,
    insights: insightReducer,
  },
});

